export const iconFontAwesomeSecurityShield = (
	<i className="fa-solid fa-shield"></i>
);
